import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Instagram, Facebook } from 'lucide-react';

const EXP_LOGO = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_collective-hub-15/artifacts/5yj12ge8_eXp-Luxury-2Color-White-Horizontal.webp';

export default function Footer() {
  return (
    <footer className="bg-[#0b0b0b] text-white/80">
      {/* Top block: brand, contact, compliance */}
      <div className="max-w-[1400px] mx-auto px-8 md:px-12 py-16 md:py-20">
        <div
          className="text-white text-2xl md:text-3xl tracking-[0.3em] mb-10"
          style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
        >
          HUNT GLOBAL COLLECTIVE
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12">
          <div className="flex items-start gap-4">
            <Mail className="w-5 h-5 text-[#b39869] mt-1 shrink-0" strokeWidth={1.2} />
            <div>
              <div className="tracking-[0.3em] text-[10px] uppercase text-white/60 mb-1">Email</div>
              <a
                href="mailto:info@huntglobalcollective.com"
                className="text-sm md:text-base text-white hover:text-[#b39869] transition-colors uppercase tracking-wider"
              >
                info@huntglobalcollective.com
              </a>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <MapPin className="w-5 h-5 text-[#b39869] mt-1 shrink-0" strokeWidth={1.2} />
            <div>
              <div className="tracking-[0.3em] text-[10px] uppercase text-white/60 mb-1">Address</div>
              <div className="text-sm md:text-base text-white uppercase tracking-wider leading-relaxed">
                15950 Dallas Pkwy Suite 400<br />
                Dallas, TX 75248
              </div>
            </div>
          </div>
        </div>

        {/* Compliance row */}
        <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8 md:gap-12 items-start pt-10 border-t border-white/10">
          <img src={EXP_LOGO} alt="eXp Realty Luxury" className="h-10 w-auto object-contain" />
          <div className="text-[12px] leading-relaxed text-white/70 space-y-2">
            <div className="flex flex-col gap-1">
              <a
                href="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-4-1.pdf"
                target="_blank"
                rel="noreferrer noopener"
                className="hover:text-[#b39869] transition-colors underline underline-offset-2"
              >
                Texas Real Estate Commission Consumer Protection Notice
              </a>
              <a
                href="https://www.trec.texas.gov/sites/default/files/pdf-forms/IABS%201-0.pdf"
                target="_blank"
                rel="noreferrer noopener"
                className="hover:text-[#b39869] transition-colors underline underline-offset-2"
              >
                Texas Real Estate Commission Information About Brokerage Services
              </a>
              <a
                href="https://www.trec.texas.gov/"
                target="_blank"
                rel="noreferrer noopener"
                className="hover:text-[#b39869] transition-colors underline underline-offset-2"
              >
                TREC Disclaimer
              </a>
            </div>
            <div className="pt-3">
              eXp Realty, LLC &middot; Office Number: (888) 519-7431
            </div>
            <div>Designated Broker: Karen E. Richards</div>
            <div className="pt-2 italic text-white/60">
              All information is deemed reliable but not guaranteed and should be independently reviewed and verified.
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-8 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-[11px] tracking-[0.2em] uppercase text-white/60">
          <div>© {new Date().getFullYear()} Hunt Global Collective. All Rights Reserved.</div>
          <div className="flex items-center gap-6">
            <Link to="/#connect" className="hover:text-[#b39869] transition-colors">Privacy Policy</Link>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/huntglobalcollective/"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Instagram"
                className="w-9 h-9 rounded-full border border-white/25 flex items-center justify-center hover:border-[#b39869] hover:text-[#b39869] transition-colors"
              >
                <Instagram className="w-4 h-4" strokeWidth={1.4} />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                className="w-9 h-9 rounded-full border border-white/25 flex items-center justify-center hover:border-[#b39869] hover:text-[#b39869] transition-colors"
              >
                <Facebook className="w-4 h-4" strokeWidth={1.4} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
